import { Box, useMediaQuery, useTheme } from "@mui/material";
import { drawerWidth, Footer, footerHeight, headerHeight, Navbar, NavbarMobile, Sidebar, useStateContext } from "@vegi.toenlioe/novitate-react-components";
import { useNavigate } from "react-router-dom";
import { MenuItems } from "../utils/Menu";
import AppRoutes from "../utils/Routes";

export default function MainPage() {
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const { menuState } = useStateContext();

    return (
        <>
            <Navbar navigate={navigate} title="Web Admin Koperasi" />
            <Sidebar menu={MenuItems} navigate={navigate} />
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    flex: 1,
                    width: menuState?.showSidebar ? `calc(100vw - ${drawerWidth}px)` : "100vw",
                    height: `calc(100vh - ${headerHeight}px - ${footerHeight}px)`,
                    '@supports (height: 100dvh)': {
                        height: `calc(100dvh - ${headerHeight}px - ${footerHeight}px)`,
                    },
                    backgroundColor: "#fff",
                    marginTop: isMobile ? 0 : `${headerHeight}px`,
                    marginBottom: isMobile ? `${headerHeight}px` : 0,
                }}
            >
                <AppRoutes />
            </Box>
        {
            isMobile ?
            <NavbarMobile navigate={navigate} />
            :
            null
        }
            <Footer navigate={navigate} />
        </>
    );
}